import { JsonChartLimit, JsonColor } from 'adapter/out/client/widgets/data/mappers/common';

export enum WIDGET_INDICATOR {
    SINGLE_KPI = 'SINGLE_KPI',
    GAUGE = 'GAUGE',
    PERCENTAGE = 'PERCENTAGE',
}

export enum WIDGET_CHART {
    SINGLE_BAR = 'SINGLE_BAR',
    SINGLE_LINE = 'SINGLE_LINE',
    STACKED_BAR = 'STACKED_BAR',
    BAR = 'BAR',
    LINE = 'LINE',
    PIE = 'PIE',
    HEATMAP = 'HEATMAP',
    MULTI_DEVICE_HEATMAP = 'MULTI_DEVICE_HEATMAP',
}

export enum WIDGET_TABULAR {
    TABLE = 'TABLE',
    LEAGUE = 'LEAGUE',
}

export enum WIDGET_OTHER {
    FLOW = 'FLOW',
    MAP = 'MAP',
    IMAGE = 'IMAGE',
    TEXT = 'TEXT',
    IFRAME = 'IFRAME',
    TIMESERIES = 'TIMESERIES',
}
enum WIDGET_NONE {
    NONE = 'NONE',
}

enum ANALYSIS {
    ANALYSIS = 'ANALYSIS',
}

enum RICH_TEXT {
    RICH_TEXT = 'RICH_TEXT',
}

export const WidgetType = { ...WIDGET_INDICATOR, ...WIDGET_CHART, ...WIDGET_TABULAR, ...WIDGET_OTHER, ...WIDGET_NONE, ...ANALYSIS, ...RICH_TEXT };
export type WidgetType = WIDGET_INDICATOR | WIDGET_CHART | WIDGET_TABULAR | WIDGET_OTHER | WIDGET_NONE | ANALYSIS | RICH_TEXT;

export class WidgetConfigurationField {
    constructor(readonly key: string, readonly value: string) {}
}
export class JsonWidgetGaugeRange {
    constructor(readonly color: JsonColor, readonly from: number, readonly to: number, readonly name: string) {}
}
export type ValueOptionConfigurationField = string | JsonWidgetGaugeRange[] | JsonChartLimit[];
export class WidgetOptionConfigurationField {
    constructor(readonly key: string, readonly value: ValueOptionConfigurationField) {}
}

export default class Widget {
    constructor(
        readonly id: string,
        readonly name: string,
        readonly type: WidgetType,
        readonly presetKey: string,
        readonly configurationFields: WidgetConfigurationField[],
        readonly optionFields: WidgetOptionConfigurationField[]
    ) {}
}
